import type { ReactNode } from 'react';
import { useRender, useT } from '../context';
import { CookieConsent } from './CookieConsent';
import { Footer, ScrollTop } from './Footer';
import { Header } from './Header';

export function SiteLayout({ children }: { children: ReactNode }) {
  const { page } = useRender();
  const t = useT();
  return (
    <>
      {page?.isPreview ? <div className="kfz-preview-banner">{t('previewBanner')} · v{page.versionNumber}</div> : null}
      <div className="boxed_wrapper">
        <Header />
        <main id="main">{children}</main>
        <Footer />
        <ScrollTop />
      </div>
      <CookieConsent />
    </>
  );
}

export function NotFound() {
  const { lang } = useRender();
  const t = useT();
  return (
    <div className="single-blog-page kfz-not-found">
      <div className="container">
        <h1>{t('notFoundTitle')}</h1>
        <p>{t('notFoundText')}</p>
        <p>
          <a className="thm-btn" href={lang === 'de' ? '/' : `/${lang}`}>
            {t('toHome')}
          </a>
        </p>
      </div>
    </div>
  );
}
